import React, { useEffect } from "react";
import { ToolTipWrapper } from "../../components/Tooltip";
import { store } from "../../index";
import { getLabelClassByName } from "../../redux/reducers/labelClasses";
import _ from "lodash";

var Quadrant = function Quadrant(_ref) {
  var label = _ref.label,
      inferences = _ref.inferences,
      selectInference = _ref.selectInference,
      color = _ref.color,
      tooltipRef = _ref.tooltipRef;

  var _store$getState = store.getState(),
      labelClasses = _store$getState.labelClasses;

  useEffect(function () {}, [inferences]);

  var selectColor = function selectColor(inference) {
    if (inference.selected) {
      return "deepskyblue";
    }

    return "white";
  };

  var getBGColor = function getBGColor() {
    if (color != null) {
      return color;
    }

    return "white";
  };

  var confidenceChart = function confidenceChart(confidences) {
    if (confidences === undefined) {
      return null;
    }

    getPredictedHexColor(confidences); // Create items array

    var items = Object.keys(confidences).map(function (key) {
      return [key, confidences[key]];
    }); // Sort the array based on the second element

    items.sort(function (first, second) {
      return second[1] - first[1];
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "flex-column-container confidence-tooltip-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "confidence-header"
    }, "Classification Strength"), _.map(_.take(items, 3), function (value) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex-row-container confidence_wrapper",
        key: value[0]
      }, /*#__PURE__*/React.createElement("div", {
        className: "confidence_tooltip",
        key: value[0] + "class"
      }, value[0]), /*#__PURE__*/React.createElement("div", {
        className: "bar-chart-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "p-bar",
        style: {
          width: Math.round(value[1] * 100).toString() + "%",
          backgroundColor: getHexColorByClassName(value[0])
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "percent-value"
      }, Math.round(value[1] * 100), "%"));
    }));
  };

  var getHexColorByClassName = function getHexColorByClassName(className) {
    // Check to see if condifence color is available. If not, it might be being edited.
    if (getLabelClassByName(labelClasses.list, className) == undefined) {
      return "#00000";
    }

    return getLabelClassByName(labelClasses.list, className).color.hex;
  };

  var getPredictedHexColor = function getPredictedHexColor(confidences) {
    var predictedClass = Object.keys(confidences).reduce(function (a, b) {
      return confidences[a] > confidences[b] ? a : b;
    });

    if (getLabelClassByName(labelClasses.list, predictedClass) == undefined) {
      return "#00000";
    }

    return getLabelClassByName(labelClasses.list, predictedClass).color.hex;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "confusion-matrix__quadrant flex-row-container flex-wrap",
    style: {
      backgroundColor: getBGColor()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "quadrant-label text-center"
  }, label), inferences.map(function (inference, id) {
    return /*#__PURE__*/React.createElement(ToolTipWrapper, {
      key: id,
      reference: tooltipRef,
      message: confidenceChart(inference.confidences)
    }, /*#__PURE__*/React.createElement("span", {
      className: "confusion-matrix__quadrant__thumb",
      key: id,
      onClick: function onClick() {
        return selectInference(inference);
      },
      style: {
        backgroundColor: selectColor(inference)
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "data:image/png;base64, ".concat(inference.img),
      alt: "".concat(label, "-").concat(id)
    })), inference.confidences != undefined && /*#__PURE__*/React.createElement("div", {
      className: "class-box",
      style: {
        backgroundColor: getPredictedHexColor(inference.confidences)
      }
    }));
  }));
};

export default Quadrant;